import { api, ApiError } from "@/api/api";
import { ImageNeedingManualEdit } from "@/api/images-types";
import { PaginatedData, QueryModels } from "@/api/utils";
import { prepareQueryParams } from "@/utils/prepare-query-params";
import { useQuery } from "@tanstack/react-query";

export function useImagesNeedingManualEdit(queryModels: QueryModels) {
  const queryParams = prepareQueryParams(queryModels);

  return useQuery<PaginatedData<ImageNeedingManualEdit>, ApiError>({
    queryKey: [
      "GET",
      "images",
      "needingManualEdit",
      JSON.stringify(queryModels),
    ],
    queryFn: () => api.images.needingManualEdit.get(queryParams),
  });
}
